

















import { Component, Mixins, Prop } from "vue-property-decorator";
import { Point, Size } from "../../domain/drawing";
import { DragKinds } from "./DragKinds";
import { DragHandleMixin } from "./mixins";

@Component({
})
export default class VectorResizeDragHandle extends Mixins(DragHandleMixin) {
  dragFrom: DragKinds = DragKinds.From;
  dragTo: DragKinds = DragKinds.To;

  @Prop()
  from: Point;

  @Prop()
  to: Point;

  @Prop()
  size: Size;

  data(): any {
    return {
      styles: this.createStyles(),
    };
  }
  styles: { toLocation: () => Point, toRectangleKinds: () => DragKinds }[];

  private createStyles(): { toLocation: () => Point, toRectangleKinds: () => DragKinds }[] {
    const results: { toLocation: () => Point, toRectangleKinds: () => DragKinds }[] = [];
    results[DragKinds.From] = {
      toLocation: () => {
        return this.from;
      },
      toRectangleKinds: () => {
        return this.toHorizontalKinds(this.from, this.to)
             | this.toVerticalKinds(this.from, this.to);
      },
    };
    results[DragKinds.To] = {
      toLocation: () => {
        return this.to;
      },
      toRectangleKinds: () => {
        return this.toHorizontalKinds(this.to, this.from)
             | this.toVerticalKinds(this.to, this.from);
      },
    };
    return results;
  }

  toHorizontalKinds(self: Point, other: Point): DragKinds {
    return (self.x < other.x)
      ? DragKinds.Left
      : DragKinds.Right;
  }

  toVerticalKinds(self: Point, other: Point): DragKinds {
    return (self.y < other.y)
      ? DragKinds.Top
      : DragKinds.Bottom;
  }

  get moveAreaSize(): Size {
    // 垂直/水平の時にドラッグできる領域がなくなるのでマージンを設ける.
    const margin = 10;
    return new Size(
      this.size.width + margin,
      this.size.height + margin
    );
  }

  get className(): string {
    return this.isDirectionUp
      ? "vector-resize-drag-handle-up"
      : "vector-resize-drag-handle-down";
  }

  get width(): number {
    return this.size.width;
  }

  get height(): number {
    return this.size.height;
  }

  get location(): Point {
    return this.styles[this.kind].toLocation();
  }

  get difference(): Point {
    return this.to.subtract(this.from);
  }

  get isDirectionUp(): boolean {
    return ((this.difference.x * this.difference.y) < 0);
  }

  get locationStyle(): any {
    const rectangleKinds = this.styles[this.kind].toRectangleKinds();
    const verticalKey = (0x0 !== (rectangleKinds & DragKinds.Top))
      ? "top"
      : "bottom";
    const horizontalKey = (0x0 !== (rectangleKinds & DragKinds.Left))
      ? "left"
      : "right";
    const result = {} as any;
    result[verticalKey] = (-this.handleHeight / 2) + "px";
    result[horizontalKey] = (-this.handleWidth / 2) + "px";
    return result;
  }
}
